const translation = {
  pt_BR: {
    title: 'Minhas Solicitações',
  },
  en_US: {
    title: 'My Requests',
  },
};

export default translation;
